import { Fund, FundProject, Entity } from 'src/types';

export const getFundAssets = (fund: Fund): FundProject[] => {
  return fund?.projectDetails?.length ? fund.projectDetails : [];
};

export function checkIsLatLngInFund(fund: Fund): boolean {
  const assets = getFundAssets(fund);

  return assets.find(asset => asset?.location?.latitude && asset?.location?.longitude)
    ? true
    : false;
}
//gets all entities with fund entity type
export function getFundsFromEntities(entities: Entity[]): Entity[] {
  return entities.filter(entity => entity.entityType === 'Fund');
}

//gets all entities with offering entity type
export function getOfferingFromEntities(entities: Entity[]): Entity[] {
  return entities.filter(entity => entity.entityType === 'Offering');
}
